var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComplete = function SvgComplete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5334 0.200841C11.2734 -0.0591587 10.8534 -0.0591587 10.5934 0.200841L6.83342 3.96084L7.77342 4.90084L11.5334 1.13417C11.7868 0.880841 11.7868 0.454175 11.5334 0.200841ZM14.3601 0.194174L7.77342 6.78084L5.45342 4.46751C5.19342 4.20751 4.77342 4.20751 4.51342 4.46751C4.25342 4.72751 4.25342 5.14751 4.51342 5.40751L7.30009 8.19417C7.56009 8.45417 7.98009 8.45417 8.24009 8.19417L15.3001 1.14084C15.5601 0.880841 15.5601 0.460841 15.3001 0.200841H15.2934C15.0401 -0.0658253 14.6201 -0.0658255 14.3601 0.194174ZM0.746758 5.41417L3.53342 8.20084C3.79342 8.46084 4.21342 8.46084 4.47342 8.20084L4.94009 7.73417L1.68676 4.46751C1.42676 4.20751 1.00676 4.20751 0.746758 4.46751C0.486758 4.72751 0.486758 5.15417 0.746758 5.41417Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComplete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/complete.f9930e0e.svg";
export { ForwardRef as ReactComponent };